/* src/app/private/components/view/users/delete-user/delete-user.component.scss */
/*# sourceMappingURL=delete-user.component.css.map */
